import React, { PureComponent } from "react";
import './index.less'

export default class PortalHeader extends PureComponent{
    constructor(props) {
        super(props)
        this.state = {
            title:"IQbots-广联达睿答平台",
            desc:"睿答平台是一个面向建筑领域的智能对话机器人平台。基于自然语言处理(NLP)等AI技术，支持软硬件开发者零代码、低成本、高质量地创建专属的智能对话机器人，实现高效便捷、多样化的人机对话体验。可服务于设计、造价、施工、运维等建筑全流程阶段，助力每一个工程项目成功。",
            // 申请使用的链接
            applicationForUseLink:"https://aecore.glodon.com/docs/chatbot/guide_1_preview.html",
            // 帮助文档的链接
            helpDocLink:"https://aecore.glodon.com/docs/chatbot/product_1_info.html ",
        }
    }
    render() {
        let { handleForUseClick , handleLinkToHelpDoc } = this
        let { title,desc } = this.state
        let { totalChatCount } = this.props
        return (
            <div className={'portal-header'}>
                <div className={'portal-heade-content w1200'}>
                    <div style={{width:672}}>
                        <h1>{title}</h1>
                        <p>{desc}</p>
                        <div className={'portal-heade-btns'}>
                            <button className={'g-btn g-btn-primary'} onClick={handleForUseClick}>申请使用</button>
                            <button className={'g-btn'} onClick={handleLinkToHelpDoc}>帮助文档</button>
                        </div>
                    </div>
                    {/*   预留展示人际会话总数懂得位置   */}
                    <div>
                        <p style={{display:"none"}}>人机对话总次数：{totalChatCount}</p>
                        <img height={280} width={500} src={require("./images/banner-logo2.png")} alt=""/>
                    </div>
                </div>
            </div>
        )
    }

    handleForUseClick = () => {
        window.open(this.state.applicationForUseLink,"_blank ");
    }

    handleLinkToHelpDoc = () => {
        window.open(this.state.helpDocLink,"_blank ");
    }
}